import client from "../api-client";
import toQueryString from "../toQueryString";
import * as env from "../../env";

// const URL = "/users.php";
const TEAM_URL = "/user_team.php";
const URL_ACCOUNT = "user_account.php";

export const getLoginUrl = () => {
  return window.location.hostname.includes("dev") ||
    window.location.hostname.includes("localhost")
    ? env.DASHBOARD_DEV_URL
    : window.location.hostname.includes("stage")
    ? env.DASHBOARD_STAGE_URL
    : env.DASHBOARD_URL;
};

export const getAuthToken = async (email) => {
  return await client(`user_get_token.php`, {
    method: "POST",
    body: {
      email: email,
    },
  });
};

export const sendRecoverPasswordEmail = async (email) => {
  return await client(`user_recover.php`, {
    method: "PUT",
    body: {
      email: email,
    },
  });
};

export const getProfile = async (id) => {
  let params = toQueryString({ uid: id });
  return await client(`user_profile.php?${params}`);
};

export const getTeam = async (id) => {
  let params = toQueryString({ uid: id });
  return await client(TEAM_URL + `?${params}`);
};

export const lastLogins = async (id) => {
  let params = toQueryString({ uid: id });
  return await client(`user_audit_logins.php?${params}`);
};

export const remove = async (id) => {
  let params = toQueryString({ uid: id });
  return await client(URL_ACCOUNT + `?${params}`, { method: "DELETE" });
};

export const suspend = async (uid, suspend) => {
  return await client(`/user_profile.php?uid=${uid}`, {
    method: "PUT",
    body: {
      suspend: suspend,
    },
  });
};

export const verify = async (uid, verify) => {
  return await client(`/user_profile.php?uid=${uid}`, {
    method: "PUT",
    body: {
      verify: verify,
    },
  });
};

export const sendAlert = async (data) => {
  return await client(`/admin/send/alert`, {
    method: "POST",
    body: data,
  });
};

export const credit = async (id) => {
  let params = toQueryString({ uid: id });
  return await client(`user_statics.php?${params}`).then(
    (response) => response.credit
  );
};

export const getLeadScores = async () => {
  return await client(`leadScores.php`);
};

export const getLeadStages = async () => {
  return await client(`leadStages.php`);
};

export const getOnBoardingStatuses = async () => {
  return await client(`onboardingStatuses.php`);
};

export const getUserTypes = async () => {
  return await client(`userTypes.php`);
};

export const getBusinessSizes = async () => {
  return await client(`businessSizes.php`);
};

export const getIndustry = async () => {
  return await client(`industries.php`);
};

export const getRole = async () => {
  return await client(`roles.php`);
};

export const getUserTags = async () => {
  return await client(`userTags.php`);
};

export const setUserTags = async (id, tags) => {
  return await client(`userTags.php`, {
    method: "POST",
    body: {
      id: id,
      tags: tags,
    },
  });
};

export const bulkAction = async (action, queryParams, postParams) => {
  return await client(`users.php?${queryParams}`, {
    method: "POST",
    body: {
      action: action,
      postParams: postParams,
    },
  });
};
